import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'antd';
import { fetchData } from '@store/noc/trendsData/actions';
import { setTrendsSorting, setAutoSortEnabled } from '@store/noc/base/actions';
import { checkIfBrowserTabIsVisible } from '@src/hooks/useBrowserTabVisibility';
import { NOC_REFRESH_INTERVAL } from '@utils/constants';
import { updatePopupVisibleSelector } from '@store/dashboards/ui/selectors';
import DataTable from '../common/DataTable';
import { columnsSelector, tableDataSelector } from './utils';
import { CheckIfUpdateDashboardPopupIsOpen } from '../common/utils';
import { dimensionSelector } from '@store/noc/trendsData/selectors';
import { useDetectError } from '../../useDetectError';

// table hoc
function TrendsTable() {
  const dispatch = useDispatch();
  const { error, isError } = useDetectError();
  const dimension = useSelector(dimensionSelector);

  const columns = useSelector(columnsSelector);
  const { data, sort, total } = useSelector(tableDataSelector);

  const onColumnSort = (sort: string) => {
    dispatch(setTrendsSorting(sort));
    dispatch(setAutoSortEnabled(false));
  };

  const updatePopupInfo = useSelector(updatePopupVisibleSelector);
  const isUpdatePopUpVisible = CheckIfUpdateDashboardPopupIsOpen(updatePopupInfo);

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      // do not do the 20 sec refresh if the user is on rt dashboard and update dashboard
      // popup is open as it rerenders the dialog box

      if (!isUpdatePopUpVisible && checkIfBrowserTabIsVisible()) {
        dispatch(fetchData());
      }
    }, NOC_REFRESH_INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, [columns, isUpdatePopUpVisible]);

  const deleteDimensionError = error.dimension[dimension];

  return (
    <>
      {deleteDimensionError && (
        <Alert
          style={{ margin: 10 }}
          message="The selected dimension does not exist. Please select another dimension"
          type="warning"
          showIcon
        />
      )}
      <DataTable
        data={deleteDimensionError ? [] : data}
        total={!isError && data?.length ? total : undefined}
        columns={columns}
        sort={sort}
        onColumnSort={onColumnSort}
      />
    </>
  );
}

export default TrendsTable;
